function OnRun($rootScope, $window, $state, $stateParams, $timeout, AppSettings, $httpBackend, AuthService) {
  'ngInject';

  $rootScope._ = _;

  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;


  $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {

    if (toState.name === "Accounts.login") {
      return; // no need to redirect 
    }

    if (toState.name === "Accounts.join") {
      return; // no need to redirect 
    }

    if (toState.name === "Accounts.privacy") {
      return; // no need to redirect 
    }

    // Intro, Result, Accounts.findId, Accounts.resetPass, Accounts.payment state 인 경우에는 로그인되어 있지 않아도 로그인 페이지로 이동시키지 않음
    if (!(toState.name === 'Intro' || toState.name === 'Result' || toState.name === 'Accounts.findId' || toState.name === 'Accounts.resetPass' || toState.name === 'Accounts.payment') && !AuthService.getUser()) {
      e.preventDefault();
      $state.go('Accounts.login');
    }

  });

  $rootScope.gmtDate = new Date('2015-01-01 00:00:00 -00:00');

  // var test = `
  // make it cheaper
  // make it cheapere
  // makeitcheaper.com.au
  // makeitcheaper
  // making it cheaper
  // www.make it cheaper
  // ww.make it cheaper.com

  // down vote
  // favorite
  // i have this simple dumy text

  // <base href="http://wjbty.lc/"/?
  // <a href="common/home" />
  // <a href="common/home" />
  // <a href="/common/home" />
  // <a href="http://common/home" />
  // <a href="https://common/home" />
  // <a href="common/home" />

  // `


  function applyGoogleTranslate() {
    var timestamp = +(new Date()),
      containerId = 'translate-temp-list' + timestamp,
      options = $('option[label]'),
      ul = $('<ul />', {
        id: containerId
      }).css({
        margin: 0,
        padding: 0,
        width: 0,
        height: 0
      });

    options.each(function(i) {
      var option = $(this);
      
      ul.append('<li style="margin:0; padding:0; width:0; height:0; visibility:hidden;" data-index="' + i + '">' + $.trim(option.attr('label')) + '</li>');
    });

    $('body').prepend(ul);

    setTimeout(function() {   // 다국어 변환이 될때까지 3초의 delay 를 줌
      options.each(function(i) {
        $(this).attr('label', $.trim(ul.children('li').eq(i).text()));
      });

      $('#' + containerId).remove();
    }, 3000);
  }


  // change page title based on state
  $rootScope.$on('$stateChangeSuccess', (event, toState) => {
    // 라우터 변경시 Scroll Top
    document.body.scrollTop = document.documentElement.scrollTop = 0;

    // $rootScope.pageTitle = '';

    // if (toState.title) {
    //   $rootScope.pageTitle += toState.title;
    //   $rootScope.pageTitle += ' \u2014 ';
    // }

    // $rootScope.pageTitle += AppSettings.appTitle;

    var $body = $('body');


    if (toState.name === 'Intro' || toState.name.match('Ssg') || toState.name.match('Accounts')) {
      $body.addClass('home-body');
      $body.removeClass('player-body');
    } else if (toState.name.match('Player') || toState.name.match('Service')) {
      $body.addClass('player-body');
      $body.removeClass('home-body');
    } else {
      $body.removeClass('home-body');
      $body.removeClass('player-body');
    }

    // // 경기 분석, 사용자 관리의 경우 좌측 메뉴 안나오도록 설정
    // if ((toState.name.match('Service') && toState.name.match('location')) || toState.name.match('Service') && toState.name.match('system')) {
    //   $(function() {
    //     $('.sidebar').css('left', -440);
    //   });
    // } else {
    //   $(function() {
    //     $('.sidebar').removeClass('ng-hide').css('left', 0);
    //   });
    // }

    // 다국어 적용
    // select 태그 내의 option label 수정
    $timeout(function() {   // option 들이 다 로딩될때까지 3초의 delay 를 줌
      applyGoogleTranslate();

      // 동적으로 생성되는 option label 의 경우 상위 select 가 change 될 때 하위 select 가 로드되는 경우이므로 아래와 같이 처리
      $('select')
        .off('change.googleTranslate')
        .on('change.googleTranslate', function() {
          setTimeout(function() {
            applyGoogleTranslate();
          }, 3000);
        });

      // 서버 API 에서 받아온 데이터 등 시간차로 인해 다국어 적용이 되지 않는 경우가 있어서 2초 delay 후 한번더 적용
      $timeout(function() {
        applyGoogleTranslate();
      }, 2000);
    }, 3000);

  });

  // android app 이 reject 되어 youtube 동영상이 background 에서 재생되지 않도록 처리
  // https://stackoverflow.com/questions/31320749/app-enables-background-playing-of-videos-cordova-issues-google-play-rejecting
  document.addEventListener("pause", function() {
    if ($rootScope.YTPlayer) {
      $rootScope.YTPlayer.stopVideo();
    }
  }, false);

  function isJSON(str) {
    try {
        var obj = JSON.parse(str);
        if (obj && typeof obj === 'object' && obj !== null) {
            return true;
        }
    } catch (err) {}
    return false;
  }
  window.isJSON = isJSON;

  // AngularJS 로 제어하지 않는 영역
  $(function () {

    // // 사이드바 펼침/닫힘
    // $body.on('click', '.side-onoff-btn', function() {

    //   if (parseInt($('.sidebar').css('left'), 10) === 0) {
    //     $(this).parent().animate({'left': '-440px'}, 200, function(){
    //       //end of animation.. if you want to add some code here
    //     });
    //     setTimeout(function() {
    //       $('.main-content').animate({'left': '-180px'}, 500, function(){
    //         //end of animation.. if you want to add some code here
    //       });
    //     }, 500);
    //   } else {
    //     $('.main-content').animate({'left': 0}, 200, function(){
    //       //end of animation.. if you want to add some code here
    //       $('.sidebar').animate({'left': 0}, 200, function(){
    //         //end of animation.. if you want to add some code here

    //       });
    //     });
    //   }

    // });

    // 태블릿 PC 등에 맞게 화면 배율 조정
    // var baseWidth = 1920,
    //   currentWidth = document.body.clientWidth;
    // $('body').css('zoom', (currentWidth / baseWidth * 100) + '%');

    // window.addEventListener('resize', function () {
    //   console.log('resize.....');
    //   $('body').css('zoom', (currentWidth / baseWidth * 100) + '%');
    // });


  });



  var timeline_team_home = [0.0667266405616298, 0.07612151751264973, 0.47659715496520527, 0.3126639644695537, 0.9094997681769832, 0.019318502341824306, 0.3190146339034443, 0.8273532953971348, 0.608673873959803, 0.39127857457441473, 0.26251739615661096, 0.2375868129101124, 0.7967748268098291, 0.570306061003325, 0.5184220379446027, 0.19369646882826586, 0.3676954399272283, 0.12883866578931502, 0.6402407735794342, 0.1710044847902099, 0.11775917893369492, 0.11077500213008662, 0.9071081686764084, 0.09643562967852937, 0.6823316199034712, 0.6687737711171404, 0.3030764811466975, 0.8007050684955668, 0.45583721202752137, 0.4210532622752068, 0.5146666112217795, 0.3487509222199332, 0.24849485550328887, 0.6610430196899544, 0.1166656385984648, 0.629073284923164, 0.40812282396793864, 0.9535979237902092, 0.23007985132857245, 0.0510028865871488, 0.35666054710801154, 0.24535649148945837, 0.2310577229394135, 0.10337690978964709, 0.7589719146052498, 0.9373807560065803, 0.703736613667096, 0.18586112924275122, 0.5114604960836937, 0.5603691049192872, 0.9673136275927328, 0.3049981748969375, 0.9199279542060532, 0.9581743439834787, 0.5890182881652626, 0.7922964878862935, 0.8502235871508041, 0.24012031085346552, 0.9240261870612017, 0.10200358528685127, 0.2413268873850718, 0.017218781109976655, 0.9682246058650574, 0.6566378127051953, 0.6466605626594737, 0.6979152823796628, 0.548615515208871, 0.48526409076549504, 0.43591374301022734, 0.9165937785558487, 0.03563778681062724, 0.8665228186605214, 0.7218671871926836, 0.6544294035179927, 0.7874729505811979, 0.07582296072720007, 0.7843847811444131, 0.45177718814944123, 0.9555988093468868, 0.4422786323961536, 0.9122205460558483, 0.7146726572105202, 0.830324326497976, 0.05402528620733027, 0.05027602225415273, 0.47064703554761067, 0.19060721893580612, 0.9920270822781267, 0.03783854739164161, 0.7105463249711614];
  var timeline_team_away = [0.7432815240152473, 0.9715046976889485, 0.6980474728150636, 0.9250371788461982, 0.9166990721637032, 0.6958357267300708, 0.9256028104079963, 0.39412434973561394, 0.24613216905021496, 0.22940941201664078, 0.9849805873615423, 0.276465357454025, 0.9121459272311851, 0.3759312910564996, 0.370076070695595, 0.5369466812210586, 0.43693140335391867, 0.9901544884919076, 0.5233471370083314, 0.37488211025401097, 0.03492284711465676, 0.12396734796230136, 0.6686881398539171, 0.4768234689576403, 0.7369806792555771, 0.7194076155794158, 0.7489934882586269, 0.44892079774637583, 0.8967895252535107, 0.28683102900226, 0.46879960136924215, 0.018777785614597198, 0.0293638451804068, 0.13138459750151799, 0.7353293457051688, 0.2475687134165252, 0.20548758438826997, 0.05595220035535253, 0.5162017861308168, 0.377765675566629, 0.3683665411507753, 0.37488143777049054, 0.924421769840923, 0.08287518632777857, 0.2599823304714999, 0.9838553279913935, 0.38380030727966274, 0.3446919949794034, 0.3901167458351644, 0.4236686706292385, 0.6064063959942156, 0.5919024752884652, 0.5832244849410713, 0.3710369898655268, 0.9254318625123543, 0.0645112408459676, 0.8500900793582893, 0.3988384415295054, 0.15551083038806035, 0.42843932765837645, 0.8089832827611594, 0.04393274671309877, 0.08451405648258348, 0.8268001453994154, 0.7168726874759945, 0.9095205089714928, 0.8672963749263669, 0.4180691912598147, 0.41450180135173675, 0.42036705107114014, 0.7303228634446683, 0.13371291165620436, 0.9270375364733723, 0.16924576126765145, 0.7293636280629527, 0.40806374813111845, 0.017609889018778135, 0.3448975500577751, 0.47458376289284687, 0.6155574918145299, 0.9165308783153008, 0.17079804864364845, 0.5088171684392313, 0.16716065323149176, 0.34554774219003437, 0.7229147586656344, 0.485421074419631, 0.05729797980328666, 0.8160092534306898, 0.9738450298015096];





}

export default OnRun;
